<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-auto flex-grow-1">
        <h3>{{ 'scan_results_report_section' | translate }}</h3>
      </div>

      @if (!$isMobile()) {
        <div class="col-auto d-flex align-items-center excluded-rules-note" data-test-id="ignored-rule" *ngIf="hasIgnoredRule">
          <svg aria-hidden="true" height="1rem" width="1rem" class="me-2" id="ignoredRuleSvg">
            <use xlink:href="#exclamation-circle"></use>
          </svg>
          <span [innerHTML]="'excluded_rules_for_scan_note' | translateHtml"></span>
          &nbsp;
          <a [routerLink]="[]" (click)="openExcludedRulesModal()" [innerHTML]="'view_excluded_rules' | translateHtml"></a>
        </div>

        <div
          class="col-auto d-flex align-items-center"
          data-test-id="view-mode-dropdown"
          *ngIf="reportView !== ScanResultsReportView.SCAN_POINT"
        >
          <span class="text-black me-3" id="pageViewSelector">{{ 'view_by' | translate }}</span>
          <select [(ngModel)]="reportView" aria-labelledby="pageViewSelector">
            <option [ngValue]="ScanResultsReportView.PAGE">{{ 'page' | translate }}</option>
            <option [ngValue]="ScanResultsReportView.RULE">{{ 'rule' | translate }}</option>
            <option *ngIf="getCanViewByComponent() | async" [ngValue]="ScanResultsReportView.COMPONENT">
              {{ 'component' | translate }}
            </option>
          </select>
        </div>
      }
    </div>
  </div>

  <div class="card-body" [ngSwitch]="reportView">
    <ng-container *ngTemplateOutlet="scanIncompleteUserFlowActionFailed"></ng-container>
    <ng-container *ngSwitchCase="ScanResultsReportView.PAGE">
      <app-view-scan-results-pages
        [scanId]="scan[$scan._id]"
        [workspaceId]="workspaceId"
        [digitalPropertyId]="digitalPropertyId"
        [auditTool]="auditTool"
        [scanAudit]="scanAudit"
      ></app-view-scan-results-pages>
    </ng-container>
    <ng-container *ngSwitchCase="ScanResultsReportView.RULE">
      <app-rule-issues-table
        *ngIf="scanSummary"
        [summary]="scanSummary"
        [scanId]="scan[$scan._id]"
        [isMonitoringTag]="isMonitoringTag"
        [auditTool]="auditTool"
        [showWcagTerminologyOnly]="true"
        [scanOrigin]="scan[$scan.scanOrigin]"
      ></app-rule-issues-table>
    </ng-container>
    <ng-container *ngSwitchCase="ScanResultsReportView.COMPONENT">
      <app-view-scan-results-components
        *ngIf="getCanViewByComponent() | async"
        [workspaceId]="workspaceId"
        [digitalPropertyId]="digitalPropertyId"
        [auditTool]="auditTool"
        [scanSummary]="scanSummary"
        [scanAudit]="scanAudit"
        [showListOfComponentsLabel]="true"
        [basePath]="basePath"
      >
      </app-view-scan-results-components>
    </ng-container>
    <ng-container *ngSwitchCase="ScanResultsReportView.SCAN_POINT">
      <app-view-scan-results-scan-points
        [scanId]="scan[$scan._id]"
        [workspaceId]="workspaceId"
        [digitalPropertyId]="digitalPropertyId"
        [auditTool]="auditTool"
        [scanAudit]="scanAudit"
      ></app-view-scan-results-scan-points>
    </ng-container>
  </div>
</div>

<ng-template #scanIncompleteUserFlowActionFailed>
  <div *ngIf="automatedUserFlowError" class="alert alert-warning" role="alert">
    <div class="d-flex">
      <div class="padding-right-sm">
        <svg class="warning-symbol" aria-hidden="true" focusable="false">
          <use xlink:href="#exclamation-triangle"></use>
        </svg>
      </div>
      <div class="padding-left-sm">
        <strong class="text-black">{{ 'scan_incomplete' | translate }}</strong>
        <div class="text-black">{{ scanIncompleteText | translate: automatedUserFlowError }}</div>
      </div>
    </div>
  </div>
</ng-template>
